import React, { useEffect, useState } from "react";
import SuggestionCard from "./SuggestionCard";
const QuesRequestComponent = (props) => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API}api/gptcomplete`
        );
        const data = await response.json();
        setData(data);
        setIsLoading(false);
      } catch (err) {
        console.log(err.message);
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="flex flex-col right-0 w-[100%] font-medium items-end justify-end ">
      <div className="flex font-montserrat md:max-w-[50%] max-w-[60%] rounded-lg md:mx-2 mx-0 md:my-1 my-2 py-1 px-2 md:text-[16px] text-sm items-center text-[#fffffd] bg-gradient-to-r from-[#286fea] to-[#1b4aef] ">
        {props.content}
      </div>
    </div>
  );
};

export default QuesRequestComponent;
